module.exports = __webpack_public_path__ + "static/media/lidingshan_plant.f0c27400.png";